import { render, staticRenderFns } from "./createTask.vue?vue&type=template&id=c2ba9b2e&lang=pug"
import script from "./createTask.vue?vue&type=script&lang=js"
export * from "./createTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports